import { RoutePreview } from '@/components/routes/route-preview';
import { OLD_TOWN_CANAL_ROUTE } from '@/lib/old-town-canal-route';

export function OldTownRoutePreview() {
  return (
    <RoutePreview
      animate
      distanceM={OLD_TOWN_CANAL_ROUTE.distanceM}
      elevationGainM={OLD_TOWN_CANAL_ROUTE.elevationGainM}
      geometry={OLD_TOWN_CANAL_ROUTE.geometry}
      name={OLD_TOWN_CANAL_ROUTE.name}
      tone="dark"
    />
  );
}
